export default __webpack_public_path__ + "static/media/about-team-kerry-zhang.6daf0136.png";